"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var Group = function(param) {
    var fw = param.fw, children = param.children, dataTestId = param["data-testid"], className = param.className;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
        w: fw ? "100%" : undefined,
        "data-testid": dataTestId,
        className: className,
        children: children
    });
};
var _default = Group;
